import { ClosedController } from './closed.controller';
import template from './closed.html';

export const closedComponent = {
  name: 'closedComponent',
  restrict: 'E',
  template,
  controller: ClosedController,
  controllerAs: 'vm',
  bindings: {
    aidRequest: '<'
  }
};
